<template>
    <footer class="footer fixed-bottom">
        <div class="container">
            <div class="row justify-content-between">
                <div class="col-4">
                    &copy;
                    <a href="http://ocom.com.au" target="_blank"
                        ><span style="color: #f78f1e">O</span
                        ><span style="color: #0059aa">com Software</span></a
                    >
                    {{ year }}
                </div>

                <div class="col-4 text-right">Version {{ version }}</div>
            </div>
        </div>
    </footer>
</template>

<style scoped>
footer {
    background-color: #f5f5f5;
}
</style>
<script>
export default {
    props: {
        year: { type: String, default: "2021" },
        version: { type: String, default: "0.0.1(beta)" },
    },
};
</script>
